import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { UnitsOfMeasure, Warehouse } from '../../../model/administration.model';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '../../../services/inventory.service';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdministratorService } from '../../../services/administrator.service';
import { gridPageRequest, gridPagination } from '../../../model/common/common.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import _ from 'lodash';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BillofmaterialLookupComponent } from '../billofmaterial-lookup/billofmaterial-lookup.component';
import { GetproductLookupComponent } from '../getproduct-lookup/getproduct-lookup.component';
import { billofmaterial, billofmaterialGridResponse, projectGridResponse, projects } from '../../../model/inventory.model';
import { Table } from 'primeng/table';
import { SalesService } from '../../../services/sales.service';

@Component({
  selector: 'app-projectbom-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  templateUrl: './projectbom-lookup.component.html',
  styleUrl: './projectbom-lookup.component.scss'
})
export class ProjectBomLookupComponent implements OnInit {
    selectedprojectbom: projects[] = [];
    searchKey : any;

    result: projectGridResponse = {
      projectBOM: [],
      totalRecords: 0
    }
    gridPagination: gridPagination = {
      first: 0,
      last: 0,
      totalRecords: 10
    }
    pageRequest: gridPageRequest = {
      pageIndex: 0,
      pageSize: 10,
      id: 0
    }

    constructor(private salesService: SalesService,private route: Router, private projectbomservice: InventoryService, public ref: DynamicDialogRef) { }
    @ViewChild('dt1') dt1: Table | undefined;

    ngOnInit(): void {
      this.getProjectBom(this.pageRequest)
    }

    getProjectBom(query: gridPageRequest) {
      this.projectbomservice.getAllProjectBom(query).subscribe({
        next: data => {
          this.result = data as projectGridResponse;
          this.pageCalculation();
        },
        error: error => {
        }
      })
    }



    // deleteBOM() {
    //   if (this.selectedbillofmaterial && this.selectedbillofmaterial.length > 0) {
    //     var productBoMId = _.map(this.selectedbillofmaterial, 'productBoMId');
    //     this.billofmaterialservice.deleteBillOfMaterial(productBoMId).subscribe({
    //       next: () => {
    //         this.selectedbillofmaterial = [];
    //         this.getBillOfMaterial(this.pageRequest);
    //       },
    //       error: () => {

    //       }
    //     });
    //   }
    // }

    pageCalculation() {
      let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
      this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
      this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
      this.gridPagination.totalRecords = this.result.totalRecords;
    }

    loadBom(event: any) {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getProjectBom(this.pageRequest);
    }

    SelectOption(event: any) {
      if (event?.data) {
        this.ref.close(event?.data);
      } else {
        this.ref.close(event);
      }
    }

    searchProjectBom(){
      if (!this.searchKey) {
        return;
      }
      this.salesService.autoSearchProjectBom(this.searchKey).subscribe(
        (data: any) => {
          if (data) {
            this.result.projectBOM = data;
            if (this.dt1) {
              this.dt1.first = 0;
            }
            this.searchKey = undefined;
          } else {
          }
        },
        (error: any) => {
          console.log(error);
        }
      );

    }
    reset(event: any) {
      this.searchKey = '';
      this.selectedprojectbom = [];
      this.getProjectBom(this.pageRequest);
  }
    refreshData(): void {
      if (this.dt1) {
            this.dt1.first = 0;
          }
        this.getProjectBom(this.pageRequest);
        }
  }
